import { H1, H2, P } from "design_lib";

export default function NorthStar() {
  return (
    <div>
      <P>
        Your mission, vision, and values are the guiding principles—or "North Star"—at the core of
        your strategy, shaping both long-term goals and everyday decisions. Mission answers the
        question, “Why do we exist?” and provides a sense of purpose. Vision articulates, “Where are
        we headed?” and offers direction and ambition. Values define, “How do we act?” and set the
        tone for decision-making and behavior. Together, they ensure that the organization stays
        aligned, resilient, and consistent in its actions. A strong North Star helps businesses
        navigate short-term complexities while maintaining focus on long-term objectives.
      </P>

      <P className="text-center">
        <i>
          “When a man does not know what harbor he is making for, no wind is the right wind.” –
          Seneca
        </i>
      </P>
      <H1>Examples:</H1>
      <H2>Amazon: Relentless customer Obsession</H2>
      <P>
        Amazon’s mission, “To be Earth's most customer-centric company,” drives both its strategic
        ambitions and day-to-day operations. From creating innovations like one-click ordering to
        investing in next-day delivery, Amazon's North Star is present in everything it does. During
        the COVID-19 pandemic, the company prioritized customer service and logistical efficiency,
        doubling down on its mission. This dual focus on short-term execution and long-term customer
        loyalty has made Amazon a leader in both customer satisfaction and profitability.
      </P>
      <H2>Nike: Aligning Vision and Action</H2>
      <P>
        Nike’s vision, “To bring inspiration and innovation to every athlete in the world,”
        permeates everything from product development to marketing campaigns. Its “Just Do It” ethos
        is more than a slogan; it’s a call to action that shapes Nike’s culture and resonates with
        its audience. This alignment between vision and action is demonstrated in the “Dream
        Crazier” campaign, which highlighted female athletes and addressed the double standards they
        face in sports. The campaign featured powerful stories of women breaking barriers and
        achieving greatness, reinforcing Nike’s commitment to gender equality and empowerment. This
        approach not only resonated deeply with its core customers but also strengthened brand
        loyalty and drove sales.
      </P>
      <H2>Microsoft: A Shift in Vision Creates Momentum</H2>
      <P>
        Microsoft’s vision shift under CEO Satya Nadella—“To empower every person and every
        organization on the planet to achieve more”—reinvigorated the company. This focus on
        empowerment guided its strategic pivot to cloud computing, leading to the success of Azure,
        Microsoft Teams, and other innovations. The clarity of this vision ensured daily alignment
        in teams across the organization, fostering both operational agility and long-term market
        leadership.
      </P>
    </div>
  );
}
